import { makeAxiosClient } from 'lib/api/ssapi/secondStepClient'
import { domains } from 'config/env'
import { formatError } from 'utils/formatError'
import { actions } from './reducer'
import { createCurriculumContentStateKey } from './selectors'

const getClient = () => makeAxiosClient(domains.CURRICULUM_SERVICE)

/**
 * Fetch content from the curriculum service POST /v1/content endpoint.
 * This single call replaces both the route-service and content-service calls.
 */
const fetchCurriculumContent = ({
  contentGroupCode,
  routePath,
  siteId,
  contentGroupVersionId,
}) => {
  return async dispatch => {
    const contentStateKey = createCurriculumContentStateKey(
      contentGroupCode,
      routePath,
      siteId,
    )
    dispatch(actions.fetchingContent({ contentStateKey }))

    try {
      const client = getClient()
      const body = {
        routePath,
        siteId,
        ...(contentGroupVersionId
          ? { contentGroupVersionId }
          : { contentGroupCode }),
      }

      const response = await client.post('/v1/content', body)
      dispatch(
        actions.fetchContentSuccess({
          contentStateKey,
          data: response.data,
        }),
      )
    } catch (error) {
      dispatch(
        actions.fetchContentError({
          contentStateKey,
          error: formatError(error),
        }),
      )
    }
  }
}

const clearErrors = () => {
  return async dispatch => {
    dispatch(actions.clearErrors())
  }
}

export default {
  fetchCurriculumContent,
  clearErrors,
}
